export default function getDefaultStage(
  codes,
) {
  const scheduledStage = codes
    .find((code) => code.entity === "Call" && code.field === "stage" && code.label === "Scheduled" );

  return scheduledStage || {};
}
